
import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import { Link, useLocation } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import ReactHtmlParser from 'react-html-parser';
import NewHeader from '../header/newheader';
import NewFooter from '../footer/newfooter';

import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
// import printJS from 'print-js';

import "./about.css"


class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contact: ''

    }
  }
  //  printTest2() {
  //   printJS('http://devifdb-be.tridz.in/print/view/pdf/publications_view/page_1?view_args[]=43054,40409,40325')

  // }
  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  fn() {
    let apis = [
      { info: { title: 'select some title' } },
      { info: { title: 'some title 2' } },
      { info: { title: 'some title 3' } }
    ];

    let toSearch = 'select'; //Will check if title have text 'search'

    let result = apis.filter(o => o.info.title.includes(toSearch));

    console.log(apis, result, 'filter');
  }

  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    // window.location.href = '/'

  }


  refreshexp() {
    let s = new Date();
    s.setSeconds(s.getSeconds() + 1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry() {
    if (localStorage.getItem('expiryref')) {
      let expref = Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if (s > expref) {
        this.signout()
      }
      else {
        this.refreshexp()
      }

    }
    else {
      this.signout()
    }
  }


  componentWillMount() {
    if (localStorage.getItem('token'))
      this.checkexpiry()

    Axios.get(BASE + 'jsonapi/node/page?filter[drupal_internal__nid]=71')
      .then((data) => {
        this.setState({
          contactitle: data.data.data[0].attributes.title,
          contact: data.data.data[0].attributes.body.value
        })
        this.topFunction()
        this.changesrc()

      })
      .catch((err) => {
        console.log('not found')
      })
  }
  changesrc() {
    const data = this.state.contact;
    const myStr = data.replace(/src="/g, `src="${BASE}`);


    this.setState({
      about: myStr
    })
  }

  render() {

    return (
      <>
        <NewHeader />
        <div className="formrea contact-page yourwork sub_work">
          <div className="title-banner"><h1 className="heading-one bold white-text">About I-BIR</h1></div>
          <div className="body listing container">

            <div className='top-contents'>
              <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /> </Link><img className='rightarrow' src={crumbarrow} />About</div>
            </div>
            {
              //   <div className="page-title">
              //   <div className="title-wrapper">
              //     <div className="container">
              //       <h1 className="heading">{this.state.contactitle ? this.state.contactitle : ''}</h1>
              //     </div>
              //   </div>
              // </div>
            }

            <div className="main-content aboutcis">
              <div className="basicpage">
                <div className="row about-text-container text-justify">
                  {ReactHtmlParser(this.state.about ? this.state.about : '')}

                </div>
              </div>
            </div>

          </div>
          {/* <button onClick={()=>this.fn()}>print</button> */}
        </div>
        <NewFooter />
      </>
    )


  }

}

export default About;